import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const columns = [
    {
        accessor: "privilege_name",
        header: "Privilege Display Name",
    },
    {
        accessor: "privilege_value",
        header: "Privilege Name",
    },
    {
        accessor: "description",
        header: "Description",
    },
];

const Privilege = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const { invalidateApi } = useGlobalAPIQueryContext();
    const [searchParams, setSearchParams] = useSearchParams();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const [privilegeEntries, setPrivilegeEntries] = useState(initialEntries);
    const [privilegePageIndex, setPrivilegePageIndex] = useState(
        initialPage - 1
    );
    const [search, setSearch] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const { useFetch } = useAPIQuery({
        key: "api/privileges",
        endpoint: "/api/privileges/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: privilegeEntries,
            page_no: privilegePageIndex + 1,
            event: search ? search : undefined,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useDelete } = useAPIQuery({
        key: "api/privileges",
        endpoint: "/api/privileges/",
    });

    const { mutate: deleteData } = useDelete({
        onSuccess: () => invalidateApi({ key: "api/roles" }),
    });

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setPrivilegePageIndex(value.pageIndex);
        setPrivilegeEntries(value.pageSize);
    };

    const handleEditRow = (row) => {
        console.log(row);
        navigate("/edit-privilege", { state: { editpost: row.original } });
    };

    const handleDeleteRow = (row) => {
        console.log(row);
        const entry_id = row.original.id;
        Swal.fire({
            text: "Are you sure? You will not be able to recover this data!",
            showDenyButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No, cancel!`,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteData({ id: entry_id });
            }
        });
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">Privilege</h3>
                    </div>
                    {privileges.includes("privilege_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-privilege"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-createrole"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-privilege"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-createrole"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Privilege</span>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>

            <Table
                data={data ? data.results.data : []}
                columns={columns}
                pagination
                pageIndex={privilegePageIndex}
                pageSize={privilegeEntries}
                rowCount={data ? data.count : 0}
                globalSearch
                isLoading={isLoading || isFetching}
                editRows={
                    privileges.includes("privilege_update") ? true : false
                }
                deleteRows={
                    privileges.includes("privilege_delete") ? true : false
                }
                filterModal={false}
                selectRows={false}
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onRowEdit={handleEditRow}
                onRowDelete={handleDeleteRow}
                onPaginationChange={handlePagination}
            />
        </>
    );
};

export default Privilege;
